module.exports = __webpack_public_path__ + "static/media/add-user-white.3895d0bb.svg";